import { ReferenceInput, SelectInput, TextInput, minLength, required } from 'react-admin';

import { useFormLanguage } from '@app/hooks/useFormLanguage';
import { Grid, Typography } from '@mui/material';

import { LanguageSelector } from '@app/components/common/LanguageSelector';
import { MultiLingualField } from '@app/components/common/MultiLingualField';

export const CreateUserForm = () => {
  const { language, handleChangeLanguage } = useFormLanguage();

  return (
    <div>
      <Typography data-cy={`create-user-form-title`} variant="h3" sx={{ marginBottom: 2 }}>
        {'ADD USER'}
      </Typography>
      <LanguageSelector language={language} handleChangeLanguage={handleChangeLanguage} />
      <Grid spacing={2} container>
        <Grid item xs={12}>
          <MultiLingualField
            Component={TextInput}
            language={language}
            source="name"
            label="Name"
            variant="outlined"
            fullWidth
            helperText="Maximum 60 characters"
            validate={[required()]}
            inputProps={{ maxLength: 60 }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            variant="outlined"
            helperText={false}
            label="Email Address"
            source="email"
            fullWidth
            validate={[required()]}
          />
        </Grid>
        <Grid item xs={6}>
          <ReferenceInput source="role" reference="users/roles">
            <SelectInput
              label="Role"
              variant="outlined"
              helperText={false}
              validate={required()}
              fullWidth
              optionText={(record) => record.description}
            />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12}>
          <TextInput
            type="password"
            variant="outlined"
            helperText={'Password must have at least eight characters'}
            label="Password"
            source="password"
            fullWidth
            validate={[required()]}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            type="password"
            variant="outlined"
            helperText={false}
            label="Confirm Password"
            source="confirm_password"
            fullWidth
            validate={[required(), minLength(8)]}
          />
        </Grid>
      </Grid>
    </div>
  );
};
